<template>
  <div class="user-org-objs-confirm_uoc org-admin_oam" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <nav-user-orgs/>

    <div class="page-container_pcr">
      <h2 class="oam_page-title">Объекты организации</h2>
    </div>

    <nav-user-org-page/>

    <div class="page-container_pcr">

      <h3 class="oam_inner-title">Одобрение новых объектов</h3>

    </div>

    <div class="page-container_pcr pcr--xl">

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="fetchData"
        layout="prev, pager, next, jumper"/>

      <div class="data-table_dta" v-if="tableData && tableData.length > 0">
        <table>
          <thead>
            <tr>
              <th>№</th>
              <th>Дата операции</th>
              <th>Объект</th>
              <th>Тип объекта</th>
              <th>IPC код</th>
              <th>Зарег. авторы</th>
              <th>Незарег. авторы</th>
              <th>Организации</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(o, i) in tableData" :key="`row-${i}`">
              <td class="text-center">{{ i + 1 }}</td>
              <td class="text-center">{{ timeToDate(o.Transient.Status.Timestamp) }}</td>
              <td><a :href="`/object/${o.ObjectId}`" target="_blank">
                {{ o.Title }}</a></td>
              <td>{{ typeTitleById(o.Type) }}</td>
              <td><a :href="`/object/${o.ObjectId}/certificate`"
                  target="_blank">{{ o.ObjectId }}</a>
              </td>
              <td><a
                v-for="(el, i) in o.Authors"
                :key="`reg-auths-${i}`"
                :href="`/user/${el.UserId}/profile/view`"
                target="_blank"
                class="dta_cell-row">
                <template v-if="el.UserId.length > 0">
                  {{ el.Surname }}
                  {{ el.Name }}
                  {{ el.Patronymic }}
                </template>
              </a></td>
              <td><div
                v-for="(el, i) in o.Authors"
                :key="`unreg-auths-${i}`">
                <template
                  v-if="el.UserId.length === 0">
                  {{ el.Surname }}
                  {{ el.Name }}
                  {{ el.Patronymic }}
                </template>
              </div></td>
              <td><div v-for="(el, i) in o.Organizations"
                :key="`orgs-${i}`">{{ el.Organization }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="tableData && tableData.length === 0" class="depo-msg_dmg dmg_themable">
        В данный момент нет объектов, ждущих одобрения.
      </div>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import OrgAdminLayoutMixin from '@/components/layouts/org-admin/UserOrgLayoutMixin';

export default {

  mixins: [OrgAdminLayoutMixin],

  data() {
    return {
      types: null,
      reportsTotal: 1,
      showNoResultsMsg: false,
    };
  },

  mounted() {
    this.$nextTick(this.fetchData);
  },

  methods: {

    typeTitleById(typeId) {
      const type = this.$store.getters['types/getType'](typeId);
      return type ? type.Title : '';
    },

    fetchData() {
      const orgId = this.$route.params.orgId;
      if (!orgId) {
        this.$notify.error('Не удалось определить организацию.');
        return;
      }
      const curUserId = this.$store.getters['user/getUserId'];
      this.reportsLoaded = 0;
      Vue.$loading.on();
      axios.get(`/users/${curUserId}/requiredSignaturesAsOrganization/${orgId}`).then((r) => {
        this.tableData = r.data;
        this.reportsLoaded += 1;
      }).catch(() => {
        this.tableData = [];
        this.reportsLoaded += 1;
        this.$notify.error('Ошибка при получении данных объектов, где необходима верификация пользователя от имени организации-правообладателя.');
      });
    },

  },

};
</script>

<style lang="scss">
@import "../../../styles/components/org-admin/common";
.user-org-objs-confirm_uoc {
  .depo-msg_dmg {
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/org-admin/UserOrgObjectsConfirm.vue